import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { outputFromObservable, toObservable } from '@angular/core/rxjs-interop';
import { uniqueId } from '@co-3/ctrl-ui/common';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';

@Component({
    selector: 'app-portal-collapsible',
    imports: [CtrlIconComponent, NgClass],
    templateUrl: './portal-collapsible.component.html',
    styleUrl: './portal-collapsible.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PortalCollapsibleComponent {
    @Input()
    public icon?: string;
    @Input()
    public title: string = '';
    @Input()
    public subtitle?: string;
    @Input()
    public alert?: string;
    // allow to force expand via binding:
    @Input()
    public set expand(value: boolean) {
        this.open.set(value);
    }
    protected open = signal(false);
    public onOpen = outputFromObservable(toObservable(this.open));

    protected uid = uniqueId('collapsible-');

    public toggleOpen(): void {
        this.open.update((isOpen) => !isOpen);
    }
}
